import { render, staticRenderFns } from "./EditAlertDialog.vue?vue&type=template&id=35a0e590&scoped=true&"
import script from "./EditAlertDialog.vue?vue&type=script&lang=js&"
export * from "./EditAlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditAlertDialog.vue?vue&type=style&index=0&id=35a0e590&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0e590",
  null
  
)

export default component.exports